import React from "react";

import { Form, FormCheckProps } from "react-bootstrap";

import classNames from "classnames";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import styles from "./RadioButtonGroup.module.scss";

type RadioOption = Omit<FormCheckProps, "type" | "label"> & { label: string };

type RadioButtonGroupProps = {
  legend: string;
  name: string;
  rules?: RegisterOptions;
  radioOptions: RadioOption[];
  defaultValue?: string;
  screenSpan?: "half-screen" | "full-screen";
} & FormCheckProps;

const RadioButtonGroup = ({
  legend,
  name,
  rules,
  radioOptions,
  defaultValue,
  screenSpan = "half-screen",
  ...rest
}: RadioButtonGroupProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <fieldset className={styles["radio-button-group-wrapper"]}>
        <legend className="b4 medium">{legend}</legend>
        {radioOptions.map((option) => (
          <Controller
            key={option.label?.toString()}
            name={name}
            control={control}
            rules={rules}
            defaultValue={defaultValue}
            render={({ field, fieldState: { error } }) => {
              return (
                <Form.Check
                  {...field}
                  {...rest}
                  className={
                    screenSpan === "half-screen"
                      ? classNames(styles["form-check"], styles["span-one-col-in-grid"])
                      : styles["form-check"]
                  }
                  type="radio"
                  defaultChecked={option.defaultChecked}
                  {...option}
                  label={<div className="b3">{option.label}</div>}
                  aria-invalid={error !== undefined}
                  value={option.label}
                  name={name}
                />
              );
            }}
          />
        ))}
        {errors?.[name]?.message && (
          <Form.Control.Feedback type="invalid" className="d-block">
            {errors?.[name]?.message.toString()}
          </Form.Control.Feedback>
        )}
      </fieldset>
    </>
  );
};

export default RadioButtonGroup;
